// extracted by mini-css-extract-plugin
export var aboveInput = "_ko-0";
export var actionButton = "_ko-5";
export var actionButtonContainer = "_ko-1";
export var actionIcon = "_ko-6";
export var aiInfoContainer = "_ko-2";
export var attachmentWrapper = "_ko-7";
export var bold = "_ko-3";
export var checkIcon = "_ko-8";
export var clickingRecipientBar = "_ko-11";
export var commentThreadSwitch = "_ko-a";
export var draftImage = "_ko-b";
export var draftImageContainer = "_ko-c";
export var draftImages = "_ko-e";
export var editButton = "_ko-g";
export var editor = "_ko-f";
export var editorContainer = "_ko-y";
export var editorErrorTooltipWrapper = "_ko-9";
export var headerDivider = "_ko-h";
export var icon = "_ko-i";
export var info = "_ko-j";
export var internal = "_ko-n";
export var internalDivider = "_ko-k";
export var internalMessage = "_ko-l";
export var messageInputCard = "_ko-m";
export var messageInputForm = "_ko-o";
export var messageInputFormInternal = "_ko-p";
export var options = "_ko-q";
export var publicMessageCustomer = "_ko-s";
export var publicMessageMerchant = "_ko-r";
export var removeImageButton = "_ko-d";
export var replyButtons = "_ko-t";
export var showSignatureButton = "_ko-u";
export var spinner = "_ko-v";
export var verticalButtonDivider = "_ko-4";
export var visibilitySelector = "_ko-w";
export var warning = "_ko-x";
export var wrappingText = "_ko-z";
export var writingInternalNoteTopBorder = "_ko-10";